function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#copy-product-url_svg__clip0_3431_5516)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M6.667 8.667a3.333 3.333 0 005.027.36l2-2A3.333 3.333 0 008.98 2.313l-1.147 1.14m1.5 3.88a3.333 3.333 0 00-5.026-.36l-2 2a3.333 3.333 0 004.713 4.714l1.14-1.14",
  stroke: "#fff",
  strokeWidth: 1.333,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}));
var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "copy-product-url_svg__clip0_3431_5516"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h16v16H0z"
})));
function SvgCopyProductUrl(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2);
}
export default SvgCopyProductUrl;